import { useState, useCallback } from "react";
import type { DynamicFilter } from "../types";

export interface FilterBuilderState {
  filters: DynamicFilter[];
  addFilter: () => void;
  updateFilter: (index: number, updates: Partial<DynamicFilter>) => void;
  removeFilter: (index: number) => void;
  clearFilters: () => void;
  setFilters: (filters: DynamicFilter[]) => void;
}

export function useFilterBuilder(
  initialFilters: DynamicFilter[] = []
): FilterBuilderState {
  const [filters, setFilters] = useState<DynamicFilter[]>(initialFilters);

  const addFilter = useCallback(() => {
    const newFilter: DynamicFilter = {
      filterBy: "",
      type: "contains",
      value: "",
    };
    setFilters((prev) => [...prev, newFilter]);
  }, []);

  const updateFilter = useCallback(
    (index: number, updates: Partial<DynamicFilter>) => {
      setFilters((prev) =>
        prev.map((filter, i) =>
          i === index ? { ...filter, ...updates } : filter
        )
      );
    },
    []
  );

  const removeFilter = useCallback((index: number) => {
    setFilters((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters([]);
  }, []);

  return {
    filters,
    addFilter,
    updateFilter,
    removeFilter,
    clearFilters,
    setFilters,
  };
}
